import apiClient from './apiClient';

const taxDeclarationService = {
  getAll: async (filters = {}) => {
    const response = await apiClient.get('/tax-declarations', { params: filters });
    return response.data;
  },

  getByFY: async (filters = {}) => {
    const response = await apiClient.get('/tax-declarations/by-fy', { params: filters });
    return response.data;
  },

  create: async (payload) => {
    const response = await apiClient.post('/tax-declarations', payload);
    return response.data;
  },

  update: async (id, payload) => {
    const response = await apiClient.put(`/tax-declarations/${id}`, payload);
    return response.data;
  },

  delete: async (id, organizationId) => {
    const response = await apiClient.delete(`/tax-declarations/${id}`, {
      params: { organizationId }
    });
    return response.data;
  }
};

export default taxDeclarationService;
